import React, {useState} from 'react';
import {ButtonGroup, Col, Row} from "reactstrap";
import ViewTable from "app/shared/view-table/view-table";
import {getPaginationFilter, paginationKeys} from "app/shared/util/pagination.constants";
import ViewTableHeaderColumn from "app/shared/view-table/view-table-header-column";
import {
  AdministrativeUnitOverviewFilterDto,
  AdministrativeUnitViewRow, initialAdministrativeUnitOverviewFilterDtoValues
} from "app/edozvola/administrative-unit-overview/model/administrative-unit-overview.model";
import {
  fetchAdministrativeUnitOverviewQuery
} from "app/edozvola/administrative-unit-overview/service/administrative-unit-overview.queries";
import {isEqual} from "lodash";
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import AdministrativeUnitFilterModal from "app/edozvola/administrative-unit-overview/administrative-unit-filter-modal";

const AdministrativeUnitOverview = () => {

  const [administrativeUnitFilter, setAdministrativeUnitFilter] = useState<AdministrativeUnitOverviewFilterDto>(getPaginationFilter(paginationKeys.ADMINISTRATIVE_UNIT_OVERVIEW) || initialAdministrativeUnitOverviewFilterDtoValues)
  const [administrativeUnitFilterShown, setAdministrativeUnitFilterShown] = useState<boolean>(false);

  const renderTableRow = (value: AdministrativeUnitViewRow) => {
    return (
      <tr key={value.idAdministrativeUnit}>
        <td>{value.administrativeUnit}</td>
        <td>{value.authority}</td>
        <td>{value.affiliations}</td>
        <td>{value.address}</td>
      </tr>
    )
  }

  const filterActive = () => {
    return !isEqual(administrativeUnitFilter, initialAdministrativeUnitOverviewFilterDtoValues);
  }

  const resetFilter = () => {
    setAdministrativeUnitFilter(initialAdministrativeUnitOverviewFilterDtoValues);
    localStorage.removeItem(`${paginationKeys.ADMINISTRATIVE_UNIT_OVERVIEW}-filter-form`);
  }

  return (
    <div className={'container-fluid view-container'}>
      <h3>Nadležni uredi</h3>
      <Row className={'mt-4'}>
        <Col>
          {!filterActive() && (
            <ButtonGroup>
              <Button
                className={'btn-full-width'}
                prependIcon={'filter'}
                size={'lg'}
                color={'primary'}
                label="Filteri"
                onClick={e => {
                  setAdministrativeUnitFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
            </ButtonGroup>
          )}
          {filterActive() && (
            <div className={'custom-btn-group'}>
              <Button
                className={'btn-group-first-button btn-primary-width'}
                prependIcon={'filter'}
                color={'info'}
                size={'lg'}
                label="Filteri"
                onClick={e => {
                  setAdministrativeUnitFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
              <TooltipWrapper message={'Poništi filtere'}>
                <Button
                  className={'btn-group-last-button btn-secondary-width'}
                  prependIcon={'xmark'}
                  color={'info'}
                  size={'lg'}
                  label=" "
                  onClick={e => {
                    resetFilter();
                    e.currentTarget.blur();
                  }}
                ></Button>
              </TooltipWrapper>
            </div>
          )}
        </Col>
      </Row>
      <Row className={'mt-4'}>
        <Col>
          <ViewTable
            renderTableRow={renderTableRow}
            fetchDataQuery={fetchAdministrativeUnitOverviewQuery}
            fetchDataProps={administrativeUnitFilter}
            noDataMessage={'Nema nadležnih ureda koji odgovaraju unesenim parametrima.'}
            localStorageKey={paginationKeys.ADMINISTRATIVE_UNIT_OVERVIEW}
            initialPaginationColumn={'administrativeUnit'}
          >
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Upravna jedinica']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Nadležno tijelo']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Područje nadležnosti']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Adresa']} />
          </ViewTable>
        </Col>
      </Row>
      <AdministrativeUnitFilterModal
        filterForm={administrativeUnitFilter}
        setFilterForm={setAdministrativeUnitFilter}
        modal={administrativeUnitFilterShown}
        closeModal={setAdministrativeUnitFilterShown}
      />
    </div>
  );
}

export default AdministrativeUnitOverview;
